import { buildRequestHeader, getCookieValue } from "./requestBuilder/buildRequestHeader.js";
import { ResponseInterceptorRequestService } from "./responseInterceptors/ResponseInterceptorRequestService.js";
import { buildUrlFromTemplate } from "./requestBuilder/buildUrlFromTemplate.js";
import { buildRequestFormData } from "./requestBuilder/buildRequestFormData.js";
import { buildRequestBody } from "./requestBuilder/buildRequestBody.js";
class RequestServiceBase extends ResponseInterceptorRequestService {
    defaultHeaders;
    privateBaseUrl = '/';
    version;
    constructor({ baseUrl, systemName }){
        super();
        this.baseUrl = baseUrl ?? this.privateBaseUrl;
        this.version = systemName && getCookieValue(`${systemName}-version`) || void 0;
    }
    setDefaultHeaders(headers) {
        this.defaultHeaders = {
            ...headers
        };
    }
    get baseUrl() {
        return this.privateBaseUrl;
    }
    set baseUrl(baseUrl) {
        this.privateBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    }
    buildUrl(templateUrl, { queryParameters, bodyParameters } = {}) {
        return buildUrlFromTemplate(`${this.baseUrl}${templateUrl}`, queryParameters, bodyParameters);
    }
    getHeaders(requestFormat) {
        return buildRequestHeader({
            version: this.version,
            defaultHeaders: this.defaultHeaders,
            requestFormat
        });
    }
    normalizeData({ bodyParameters, format } = {}) {
        if (null == bodyParameters) return;
        if ('FormData' === format) return buildRequestFormData(bodyParameters);
        return buildRequestBody(bodyParameters);
    }
}
export { RequestServiceBase };
